import React from 'react';
import { createRoot } from 'react-dom/client';
import PortalInvoicePayment from './App';

const elementContainer = document.querySelector<HTMLElement>('#portal-invoice-payment-root');

if (elementContainer) {
  const root = createRoot(elementContainer);
  root.render(<PortalInvoicePayment />);
}
